module.exports = __webpack_public_path__ + "static/media/vision-idea-map.a31fdde9.png";